import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import "@/ch.css";
import { Chip, FS, TZ } from "@/components/ch/ui";
import { api, errMsg, todayISO } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/components/staff/Panel";

const dlc = (n) => (n < 0 ? "var(--er)" : n <= 5 ? "var(--wa)" : "var(--ok)");
const dlt = (n) => (n < 0 ? `${-n}d late` : n === 0 ? "Today" : `${n}d left`);
const age = (s) => (s ? Math.max(0, Math.round((new Date(`${todayISO()}T00:00:00`) - new Date(`${s.slice(0, 10)}T00:00:00`)) / 864e5)) : null);

export default function Waiting() {
  const { user } = useAuth();
  const go = useNavigate();
  const [L, setL] = useState(null);
  const [q, setQ] = useState("");
  const load = () => api.get("/queues/waiting").then((r) => setL(r.data)).catch((e) => { toast.error(errMsg(e)); setL([]); });
  useEffect(() => { load(); }, []);
  const remind = (x) => api.post(`/queues/waiting/${x.id}/remind`, { kind: x.kind }).then(() => { toast.success("Reminder sent to the client"); load(); }).catch((e) => toast.error(errMsg(e)));
  const open = (x) => go(x.kind === "request" ? "/quotes?tab=reqs" : `/tasks?open=${x.kind === "task" ? x.id : x.task_id}`);
  const F = (L || []).filter((x) => !q || `${x.title} ${x.company}`.toLowerCase().includes(q.toLowerCase()));
  const G = { gridTemplateColumns: "minmax(0,1.6fr) minmax(0,1.4fr) 80px 100px minmax(0,1fr) 150px" };
  return (
    <div className="ch chs" data-testid="staff-waiting">
      <h1 className="vh1">Waiting on client</h1><p className="mu">Everything stuck on a client, most urgent deadline first.</p>
      <div className="tb"><input className="sel" placeholder="Search client or task…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="wait-search" style={{ flex: "1 1 240px" }} /></div>
      {L === null ? <p className="mu">Loading…</p> : <>
        <div className="vw vwh" style={G}><span>Client and task</span><span>Reason</span><span>Waiting</span><span>Deadline</span><span>Reminders</span><span></span></div>
        {F.map((x) => (
          <div key={`${x.kind}-${x.id}`} className="vw" style={G} data-testid={`wait-row-${x.id}`}>
            <span><b>{x.title}</b><small>{x.company} · {x.kind === "task" ? "task" : x.kind === "request" ? "service request" : "assistance request"}</small></span>
            <span>{x.reason}{x.amount ? <small>{TZ(x.amount)}</small> : null}{x.alert && <small style={{ color: "var(--er)" }}>{x.alert}</small>}</span>
            <span>{age(x.since) ?? "—"}{age(x.since) != null ? " d" : ""}</span>
            <span>{x.days != null ? <Chip c={dlc(x.days)}>{dlt(x.days)}</Chip> : "—"}</span>
            <span><small>Last: {x.last_reminder ? FS(x.last_reminder) : "—"}</small>{x.next_reminder && <small>Next automatic: {FS(x.next_reminder)}</small>}</span>
            <span className="vact">{can(user, "queues_remind") && <button className="b g sm" onClick={() => remind(x)} data-testid={`wait-remind-${x.id}`}>Remind</button>}<button className="b g sm" onClick={() => open(x)} data-testid={`wait-open-${x.id}`}>Open</button></span>
          </div>))}
        {!F.length && <p className="mu" data-testid="wait-empty">Nothing is waiting on a client.</p>}</>}
    </div>
  );
}
